import { render, staticRenderFns } from "./RegisteredAddresses.vue?vue&type=template&id=5f235e90&scoped=true"
import script from "./RegisteredAddresses.vue?vue&type=script&lang=js"
export * from "./RegisteredAddresses.vue?vue&type=script&lang=js"
import style0 from "./RegisteredAddresses.vue?vue&type=style&index=0&id=5f235e90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f235e90",
  null
  
)

export default component.exports